import React from "react";
import f from "../images/f.png"
import linked from "../images/in.png"
import insta from "../images/insta.png"

export default function Social(){
    return(
        <div className="contact-container">
            <p className="home-social">GET SOCIAL</p>
            <div className="line"></div>
            <a href="https://linktr.ee/coloranti" rel="noreferrer" target="_blank"><img src={f} alt="facebook logo" className="facebook"/></a>
            <a href="https://linktr.ee/coloranti" rel="noreferrer" target="_blank"><img src={linked} alt="linked logo" className="linkedin"/></a>
            <a href="https://linktr.ee/coloranti" rel="noreferrer" target="_blank"><img src={insta} alt="instagram logo" className="instagram"/></a>
        </div>
    )
}